import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';

interface EditableListenerPluginProps {
    editable: boolean;
}

const EditableListenerPlugin = ({ editable }: EditableListenerPluginProps) => {
    const [editor] = useLexicalComposerContext();

    useEffect(() => editor.setEditable(editable), [editor, editable]);

    return null;
};

export default EditableListenerPlugin;
